module.exports = __webpack_public_path__ + "img/L 13.8a6beeb1.png";